import handleError from 'common/helpers/handleError';
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('app', ['account']),
    isMasquerade() {
      return this.$q.cookies.has('isMasquerade') && !!this.account?.parent;
    },
  },
  methods: {
    async onLoginAsClient(childUserId) {
      try {
        const { data } = await this.$axios.post('user/auth/child', { childUserId });
        const href = `${process.env.WEBBYMIZE_DOMAIN}/dashboard/?clientToken=${data.data.token}`;
        window.location.href = href;
      } catch (error) {
        handleError(error);
      }
    },
  },
};
